import { render, staticRenderFns } from "./InforNewCampMail.vue?vue&type=template&id=fdba9216&scoped=true&"
import script from "./InforNewCampMail.vue?vue&type=script&lang=js&"
export * from "./InforNewCampMail.vue?vue&type=script&lang=js&"
import style0 from "./InforNewCampMail.vue?vue&type=style&index=0&id=fdba9216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdba9216",
  null
  
)

export default component.exports